import SyncMapsUpdateAccordion from '../../../components/sections/sync-maps-update-accordion/sync-maps-update-accordion';
import SyncMapsVehicleCard from '../../../components/sections/sync-maps-vehicle-card/sync-maps-vehicle-card';
import React from 'react';
import {
    SyncMapAccordionContent,
    SyncMapsConsolidatedResponse,
    SyncMapStatus,
} from '../../../views/sync-maps-updates-view/hooks/use-syncs-maps-status-updates';
import SyncMapsUpdatesVw from '../sync-maps-updates-vw/sync-maps-updates-vw';

interface Props {
    setSyncOption: (event: any) => void;
    setMapsOption: (event: any) => void;
    syncAccordionContent: SyncMapAccordionContent;
    vwAccordionContent: SyncMapAccordionContent;
    ctrAccordionContent: SyncMapAccordionContent;
    mapAccordionContent: SyncMapAccordionContent;
    syncMapsUpdates: SyncMapsConsolidatedResponse;
    syncMapContent: SyncMapStatus;
}

const syncMapsUpdatesCtr = (props: Props) => {
    const hasCtr = props.ctrAccordionContent.hasCtr;

    return (
        <>
            {hasCtr ? (
                <div className="sync-maps-accordions-and-card">
                    <div className="sync-maps-updates-accordions">
                        {props.ctrAccordionContent.cards && (
                            <SyncMapsUpdateAccordion
                                setSelectedOption={props.setSyncOption}
                                syncMapsConsolidatedResponse={
                                    props.syncMapsUpdates
                                }
                                {...props.ctrAccordionContent}
                            />
                        )}
                        <SyncMapsUpdateAccordion
                            {...props.mapAccordionContent}
                            ctrUnavailableMapUpdate={hasCtr}
                        />
                    </div>

                    <div className="sync-maps-vehicle-and-article">
                        <SyncMapsVehicleCard
                            syncMapsConsolidatedResponse={props.syncMapsUpdates}
                            hasCtr={
                                props.syncMapsUpdates.syncMapUpdateResponse
                                    .syncUpdateResponse.hasCtr
                            }
                            ctrHide={props.syncMapContent.ctrHide}
                            hasSync={props.syncAccordionContent.hasSync}
                        />
                    </div>
                </div>
            ) : (
                <SyncMapsUpdatesVw
                    setSyncOption={props.setSyncOption}
                    setMapsOption={props.setMapsOption}
                    syncAccordionContent={props.syncAccordionContent}
                    vwAccordionContent={props.vwAccordionContent}
                    syncMapsUpdates={props.syncMapsUpdates}
                    mapAccordionContent={props.mapAccordionContent}
                />
            )}
        </>
    );
};

export default syncMapsUpdatesCtr;
